import db from '@/db'
import moment from 'moment-timezone'

const modules = {};

const initState = {
    loading: false,
    active: [],
    cutoffInterval: null,
    cutoffDate: null
};

const state = () => {
    return Object.assign({}, initState)
};
const getters = {
    db() {
        return db.firestore.workouts
    },
    cutoffDate(state, getters) {
        return getters['cutoff'].toDate()
    },
    cutoff(state) {
        return (state.cutoffDate || moment())
    }
};
const mutations = {
    active(state, value) {
        state.active = Array.from(value)
    },
    loading(state, value) {
        state.loading = !!value
    },
    cutoffInterval(state, value) {
        if (value) {
            state.cutoffInterval = value
        } else {
            clearInterval(state.cutoffInterval);
            state.cutoffInterval = null
        }
    },
    cutoffDate(state, value) {
        value = value.clone()
        // console.log("SETTING CUTOFF", value)
        if (!value) {
            value = null
        } else if (!moment.isMoment(value)) {
            value = moment(value)
        }
        if (value) {
            value.subtract(2, 'hours')
            state.cutoffDate = value
        }
    }
};

const actions = {
    load({state, commit, dispatch}, payload) {
        if (state.loading) {
            return Promise.reject('Already loading checkouts')
        }
        if (state.cutoffDate === null) {
            dispatch('toggleCutoffInterval', true)
        }
        // console.log("CUTOFF", state.cutoffDate)
        commit('loading', true);
        return dispatch('get', payload)
            .then((workouts:Array<object>) => {
                commit('active', workouts);
                commit('loading', false);
                return workouts
            })
            .catch((error) => {
                commit('loading', false);
                return Promise.reject(error)
            })
    },
    get({getters}, payload:any=null) {
        const db = getters['db']

        // console.log('CD', getters['cutoffDate'])
        return db.where("date", ">=", getters.cutoffDate)
            .orderBy("date", "asc")
            .get()
            .then((snapshot:any) => {
                const workouts:Array<object> = [];
                snapshot.forEach((workout) => {
                    const data = workout.data();
                    data.date = moment(data.date.toMillis());
                    data.date.local()
                    data.id = workout.id
                    workouts.push(data)
                })
                // console.log("DATA", workouts)
                return workouts
            })
    },
    toggleCutoffInterval({state, commit}, payload:any=null) {
        if (payload === null) {
            payload = !(state.cutoffInterval)
        }
        if (payload) {
            // console.log("SET INTERVAL")
            commit('cutoffDate', moment())
            const i = setInterval(() => {
                commit('cutoffDate', moment())
            }, 10000);
            commit('cutoffInterval', i)
        } else {
            commit('cutoffInterval', null);
            commit('cutoffDate', null)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules
}
